import React from 'react';
import classNames from 'classnames';
import { ButtonItem, NavigationContent, NavigationHeader, SideNavigation } from '@atlaskit/side-navigation';
import { HeadingItem } from '@atlaskit/menu';
import { useFeatureToggle } from '@css-xp/base';
import { ENABLE_DESIGN_ITERATION_1 } from '@css-xp/ppc-constants';
import WorldIcon from '@atlaskit/icon/glyph/world';
import { EmailNotifications } from './components/emails-details-section/emails-notification';
import './notification-preferences-page.scss';

export const NotificationPreferencePage = () => {
  const [isEnabled] = useFeatureToggle();
  const isDesignIteration1Enabled = isEnabled(ENABLE_DESIGN_ITERATION_1);

  return (
    <div className="notification-preference-container">
      {isDesignIteration1Enabled || (
        <div className="notification-preference-side-navigation">
          <SideNavigation label="notification-preference-settings">
            <NavigationHeader>
              <HeadingItem>Settings</HeadingItem>
            </NavigationHeader>
            <NavigationContent showTopScrollIndicator>
              <div className="side-navigation-btn">
                <ButtonItem isSelected={true} iconBefore={<WorldIcon label="" />}>
                  Emails
                </ButtonItem>
              </div>
            </NavigationContent>
          </SideNavigation>
        </div>
      )}
      <div
        className={classNames('notifications-setting-email-details-sections', {
          'email-details-sections-v2': isDesignIteration1Enabled,
        })}
      >
        <EmailNotifications />
      </div>
    </div>
  );
};
